import BudgetControlCardSortBy from "../BudgetControlCard/BudgetControlCardSortBy";
import { BUDGET_GRAPH_ENABLED_SORT_KEYS } from "../../helpers/budgetSort";

interface BudgetControlGraphSortByProps {
  sortKey: string;
  sortDir: "asc" | "desc";
  onApply: (key: string, dir: "asc" | "desc") => void;
  // Defaults to enabling every budget metric (same set as the card view)
  enabledValues?: Set<string>;
}

// Graph view reuses the Card sort-by drawer with all budget metrics selectable.
export default function BudgetControlGraphSortBy({
  sortKey,
  sortDir,
  onApply,
  enabledValues = BUDGET_GRAPH_ENABLED_SORT_KEYS,
}: BudgetControlGraphSortByProps) {
  return (
    <BudgetControlCardSortBy
      sortKey={sortKey}
      sortDir={sortDir}
      onApply={onApply}
      enabledValues={enabledValues}
    />
  );
}
